import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  browserGpsInfo,
  checkScanDistanceGreater,
  formatDateTimeStamp,
  getEventUpdateDetails,
  isLargeScreen,
} from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { userUpdateTable } from '../../../pages/pages/tableDetails';
import { DataCheckService } from '../../services/data-check.service';
import { MediaPreviewComponent } from '../media-preview/media-preview.component';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';

@Component({
  selector: 'gtapp-updated-event-detail',
  templateUrl: './updated-event-detail.component.html',
  styleUrl: './updated-event-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UpdatedEventDetailComponent implements OnInit, OnChanges {
  @Input() selectedEvent: any;
  @Input() selectedEventFrom: string = 'job';
  @Input() extraCheck: boolean = false;
  @Input() userEventDetailsTableView: any;

  @Output() editUserComment = new EventEmitter();
  @Output() deleteRestoreUserUpdate = new EventEmitter();
  @Output() goBack = new EventEmitter();

  browserGpsInfo: any = browserGpsInfo;
  canEditEventUpdate: boolean = false;
  canDeleteRestoreCommentPhoto: boolean = false;
  lastCommentEditTime: any;

  subscriberUserId: any;
  isAdmin: boolean = false;
  isDispatchUser: boolean = false;
  scanDistanceInfo: any = {};

  isLargeScreen = isLargeScreen;

  restoredDetails: any;
  deletedDetails: any;
  editedDetails: any;
  constructor(
    private dataCheckService: DataCheckService,
    private appService: AppService,
    private dialogService: ModalDialogueService,
  ) {}
  ngOnInit(): void {
    this.isAdmin = this.dataCheckService.isUserAdmin();
    this.isDispatchUser = this.dataCheckService.isDispatchUser();
    let userData = this.appService.getUserData();

    this.subscriberUserId = userData?.subscriber?.subscriber_user_id;

    if (!this.userEventDetailsTableView) {
      this.userEventDetailsTableView = userUpdateTable.desktopTable;
    }
    this.fetchResults();
    this.appService.initializeBootstrapTooltips();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.isLargeScreen)
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 50);

    this.fetchResults();
  }
  fetchResults() {
    this.scanDistanceInfo = {};

    if (
      this.selectedEventFrom === 'job' &&
      [33, 40, 42].includes(this.selectedEvent?.event_action) &&
      this.selectedEvent?.detail
    ) {
      try {
        const timeStamp =
          Number(this.selectedEvent?.detail) || this.selectedEvent?.detail;

        if (timeStamp)
          switch (this.selectedEvent?.event_action) {
            case 33:
              this.selectedEvent.detail = formatDateTimeStamp(
                new Date(timeStamp),
                'd MMMM y',
                'en_US',
              );
              break;
            case 40:
              this.selectedEvent.detail = formatDateTimeStamp(
                new Date(timeStamp),
                'd MMMM y HH:mm',
                'en_US',
              );
              break;
            case 42:
              this.selectedEvent.detail = formatDateTimeStamp(
                new Date(timeStamp),
                'd MMMM y HH:mm',
                'en_US',
              );
              break;
          }
      } catch (error) {}
    }

    this.canEditEventUpdate = this.canEditEventUpdateCheck();
    // this.getDetails();
    // this.restoredDetails = this.getRestoreDetails();
    // this.deletedDetails = this.getDeleteDetails();
    // this.editedDetails = this.getEditedDetails();
    const details = getEventUpdateDetails(
      this.selectedEvent,
      this.selectedEventFrom,
    );

    this.restoredDetails = details?.restore;
    this.deletedDetails = details?.delete;
    this.editedDetails =
      details?.editedPatrol ||
      details?.editedJob ||
      details?.editedIncident ||
      details?.editedRunsheet;

    this.canDeleteRestoreCommentPhoto = this.canDeleteRestorUpdate();

    if (
      this.selectedEvent?.history_changes?.length &&
      (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
        this.isAdmin ||
        this.isDispatchUser)
    ) {
      let sortedComments = this.selectedEvent?.history_changes?.sort(
        (a: any, b: any) =>
          new Date(a?.updated_at).getTime() - new Date(b?.updated_at).getTime(),
      );
      this.lastCommentEditTime = sortedComments[sortedComments?.length - 1];
    }

    if (
      this.selectedEvent &&
      this.selectedEvent?.checkpoint_details &&
      this.selectedEvent?.checkpoint_details?.id
    ) {
      if ([0, 6, 12].includes(this.selectedEvent?.event_action)) {
        this.selectedEvent.gps.gpsToolTip = 'Scan Location';
      }
      this.scanDistanceInfo = checkScanDistanceGreater(this.selectedEvent);

      if (this.scanDistanceInfo?.scanDistance)
        this.selectedEvent.checkpoint_details.scanDistanceInfo =
          this.scanDistanceInfo;
    }
  }

  hideDetails() {
    this.goBack.emit();
  }
  canDeleteRestorUpdate() {
    switch (this.selectedEventFrom) {
      case 'runsheet':
        return (
          (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
            this.isAdmin ||
            this.isDispatchUser) &&
          [10].includes(this.selectedEvent?.event_action) &&
          this.extraCheck
        );
      case 'job':
        return (
          (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
            this.isAdmin ||
            this.isDispatchUser) &&
          [7, 8, 19].includes(this.selectedEvent?.event_action) &&
          this.extraCheck
        );
      case 'patrol':
        return (
          (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
            this.isAdmin ||
            this.isDispatchUser) &&
          this.selectedEvent?.company_id &&
          [1, 2, 7].includes(this.selectedEvent?.event_action) &&
          new Date().getTime() -
            new Date(this.selectedEvent?.updated_at).getTime() <
            72 * 3600 * 1000 &&
          this.extraCheck
        );

      case 'user_update_history':
        return (
          (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
            this.isAdmin) &&
          this.selectedEvent?.event_type === 'Patrol Update' &&
          [1, 2, 7].includes(this.selectedEvent?.event_action) &&
          new Date().getTime() -
            new Date(this.selectedEvent?.updated_at).getTime() <
            3600 * 1000 &&
          this.extraCheck
        );
    }
    return false;
  }

  canEditEventUpdateCheck() {
    switch (this.selectedEventFrom) {
      case 'runsheet':
        return (
          (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
            this.isAdmin ||
            this.isDispatchUser) &&
          [10].includes(this.selectedEvent?.event_action) &&
          this.extraCheck
        );
      case 'job':
        return (
          (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
            this.isAdmin ||
            this.isDispatchUser) &&
          [7, 8, 19].includes(this.selectedEvent?.event_action) &&
          this.extraCheck
        );
      case 'patrol':
        return (
          (this.subscriberUserId == this.selectedEvent?.subs_user_id ||
            this.isAdmin ||
            this.isDispatchUser) &&
          this.selectedEvent?.company_id &&
          [1, 2, 7].includes(this.selectedEvent?.event_action) &&
          new Date().getTime() -
            new Date(this.selectedEvent?.updated_at).getTime() <
            72 * 3600 * 1000 &&
          this.extraCheck
        );
      case 'user_update_history':
        return (
          this.subscriberUserId == this.selectedEvent?.subs_user_id &&
          this.selectedEvent?.company_id &&
          this.selectedEvent?.event_type === 'Patrol Update' &&
          [1, 2, 7].includes(this.selectedEvent?.event_action) &&
          new Date().getTime() -
            new Date(this.selectedEvent?.updated_at).getTime() <
            72 * 3600 * 1000 &&
          this.extraCheck
        );
    }
    return false;
  }

  getLastCommentEditedDateTime(history: any) {
    let sortedComments = history?.sort(
      (a: any, b: any) =>
        new Date(a?.updated_at).getTime() - new Date(b?.updated_at).getTime(),
    );
    return sortedComments[sortedComments?.length - 1];
  }
  onOpenFile(file: any) {
    this.dialogService.open(MediaPreviewComponent, {
      data: {
        mediaSrc: file?.file,
        timeStamp: file.updated_at,
        mediaExtension: file?.file_extension,
      },
    });
  }
}
